function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, demoProjects, loadingProjects, selectedDemo, waitingOnResponse) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'mp-demo-selector-modal': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-modal", {
          "attrs": __vjadeStringifyAttrsIfObj({
            closeable: true,
            open: true,
            'grow-to-content': true,
          }),
          "class": {
            'modal': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-modal-large-content': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'header': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(($attr(`is-fyt`)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("While you wait...");;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Select Sample Dataset");;
                  return __jade_nodes
                }).call(this)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-modal-text': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(($attr(`is-fyt`)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(`Feel free to check out our demo projects!`);
                  __jade_nodes = __jade_nodes.concat(h("div", (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(`If you know `);
                    __jade_nodes = __jade_nodes.concat(h("span", {
                      "class": {
                        'bold': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("" + ($attr(`owner-email`)) + "");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(`, you can try to contact them directly for faster approval. You will receive an email confirmation once your request has been approved.`);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("You can easily switch between datasets in the Demo view");;
                  return __jade_nodes
                }).call(this)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'modal-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((loadingProjects) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'spinner-wrapper': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-spinner", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        color: `blue`,
                        size: `large`,
                      }),
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'datasets-wrapper': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((function() {
                      var $$obj = (demoProjects);
                      var $$eachNodes;
                      var $$iterated = false;
                      if (Array.isArray($$obj)) {
                        $$eachNodes = $$obj.reduce(function($$eachNodes, project, $index) {
                          $$iterated = true;
                          return $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-dataset-card", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                'img-name': project.icon,
                                text: project.description,
                                'project-id': project.projectId,
                                selected: selectedDemo === project.projectId,
                              }),
                              "on": {
                                click: () => $helpers.clickedDataset(project.projectId)
                              },
                            }));;
                            return __jade_nodes
                          }).call(this));
                        }, []);
                      } else {
                        $$eachNodes = [];
                        for (var $$objKey in $$obj) {
                          (function() {
                            var $index = $$objKey;
                            if ($$obj.hasOwnProperty($index)) {
                              $$iterated = true;
                              var project = $$obj[$index];
                              $$eachNodes = $$eachNodes.concat((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("mp-dataset-card", {
                                  "attrs": __vjadeStringifyAttrsIfObj({
                                    'img-name': project.icon,
                                    text: project.description,
                                    'project-id': project.projectId,
                                    selected: selectedDemo === project.projectId,
                                  }),
                                  "on": {
                                    click: () => $helpers.clickedDataset(project.projectId)
                                  },
                                }));;
                                return __jade_nodes
                              }).call(this));
                            }
                          })();
                        }
                      }

                      return $$eachNodes;
                    })());;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'explore-demo-button': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-button", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        theme: `primary`,
                        disabled: !selectedDemo || waitingOnResponse,
                        elref: `submitButton`
                      }),
                      "on": {
                        click: () => $helpers.clickedExploreDemoButton()
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((waitingOnResponse) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-spinner", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            color: `white`
                          }),
                        }));;
                        return __jade_nodes
                      }).call(this)) : ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Explore Demo");;
                        return __jade_nodes
                      }).call(this)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "demoProjects" in locals ? locals.demoProjects : typeof demoProjects !== "undefined" ? demoProjects : undefined, "loadingProjects" in locals ? locals.loadingProjects : typeof loadingProjects !== "undefined" ? loadingProjects : undefined, "selectedDemo" in locals ? locals.selectedDemo : typeof selectedDemo !== "undefined" ? selectedDemo : undefined, "waitingOnResponse" in locals ? locals.waitingOnResponse : typeof waitingOnResponse !== "undefined" ? waitingOnResponse : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;